import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { FirmsListModalComponent } from 'src/app/modules/firm/components/firms-list-modal/firms-list-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
  ],
  declarations: [
    FirmsListModalComponent,
  ],
  exports: [
    FirmsListModalComponent,
  ],
})
export class FirmModule { }
